export default "__VITE_ASSET__CzANs72n__"